import { useState } from "react"

import { parseErrorAsObj } from "../../../../errors/errorProcessors"
import { IAppError } from "../../../../errors/errorTypes"
import { snackbar } from "../../../../utils/general/generalUtils"
import { postClientProtected } from "../../clients/clients"
import { EDIT_ORG } from "../../urls/private"

interface IEditOrganisationHook {
    isSending: boolean
    error: IAppError | undefined
    postResponse: (payload: IEditOrgPayload) => Promise<void>
}

interface IEditOrgPayload {
    org_name: string
    org_address: string
    org_address_line_2?: string
    org_postcode: string
    org_phone_number: string
    installer_individual_phone_number?: string
}

const useEditOrganisation = (): IEditOrganisationHook => {
    const [isSending, setIsSending] = useState(false)
    const [error, setError] = useState<IAppError | undefined>(undefined)

    const postResponse = async (payload: IEditOrgPayload): Promise<void> => {
        try {
            setIsSending(true)
            await postClientProtected(EDIT_ORG, payload)
            snackbar("Organisation details updated successfully", "success")
        } catch (err) {
            const errorObj = parseErrorAsObj(err)
            setError(errorObj)
            snackbar("Failed to update organisation details", "error")
        } finally {
            setIsSending(false)
        }
    }

    return {
        error,
        isSending,
        postResponse,
    }
}

export default useEditOrganisation
